var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    }
  }, [_c("el-form-item", [_c("el-radio-group", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.unread,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "unread", $$v);
      },
      expression: "searchForm.unread"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("未读")]), _c("el-radio-button", {
    attrs: {
      label: "0"
    }
  }, [_vm._v("已读")])], 1)], 1)], 1), _c("el-form", {
    attrs: {
      size: "small"
    }
  }, [_c("el-form-item")], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "用户名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfo = _ref.row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "chName",
      label: "用户头像"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-image", {
          attrs: {
            src: scope.row.user.avatar,
            width: "60",
            compression: true
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "recordCount",
      label: "总聊天数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "unread",
      label: "未读消息"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "lastTime",
      label: "最后聊天时间"
    }
  }), _c("el-table-column", {
    attrs: {
      fixed: "right",
      label: "操作",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.goChat(scope.row);
            }
          }
        }, [_vm._v("聊天")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };